import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { scheduleAListService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateScheduleADefaultMutation = onSuccess => {
	const dispatch = useDispatch();

	return useMutation(
		({
			agentId,
			scheduleId,
			isDefault,
		}: {
			agentId: string;
			scheduleId: string;
			isDefault: boolean;
		}) => {
			dispatch(uiActions.showSpinnerOverlay());
			return scheduleAListService.updateScheduleADefault({
				agentId,
				scheduleId,
				isDefault,
			});
		},
		{
			onSuccess() {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useUpdateScheduleADefaultMutation;
